"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateByItemId = exports.state = exports.getItemById = exports.getItems = void 0;
function getItems(objectType) {
    return (rootState) => {
        const workspaceId = rootState.workspaces.activeWorkspaceId;
        if (!rootState.entities.items.has(`${workspaceId}:${objectType}`)) {
            return [];
        }
        return rootState.entities.items
            .get(`${workspaceId}:${objectType}`)
            .map((itemId) => rootState.entities.entitiesById.get(`${workspaceId}:${objectType}:${itemId}`));
    };
}
exports.getItems = getItems;
function getItemById(objectType, itemId) {
    return (rootState) => {
        const workspaceId = rootState.workspaces.activeWorkspaceId;
        if (!rootState.entities.entitiesById.has(`${workspaceId}:${objectType}:${itemId}`)) {
            return;
        }
        return rootState.entities.entitiesById.get(`${workspaceId}:${objectType}:${itemId}`);
    };
}
exports.getItemById = getItemById;
function state(objectType) {
    return (rootState) => {
        const errorMessage = rootState.entities.errorMessage.has(objectType)
            ? rootState.entities.errorMessage.get(objectType)
            : null;
        const isProcessing = rootState.entities.isProcessing.has(objectType)
            ? rootState.entities.isProcessing.get(objectType)
            : false;
        const itemErrorMessage = rootState.entities.errorMessage.has(`${objectType}:item`)
            ? rootState.entities.errorMessage.get(`${objectType}:item`)
            : null;
        const isItemProcessing = rootState.entities.isProcessing.has(`${objectType}:item`)
            ? rootState.entities.isProcessing.get(`${objectType}:item`)
            : false;
        const metadata = rootState.entities.metadata.has(objectType)
            ? rootState.entities.metadata.get(objectType)
            : {};
        return { errorMessage, itemErrorMessage, isProcessing, isItemProcessing, metadata };
    };
}
exports.state = state;
function stateByItemId(objectType, objectId) {
    return (rootState) => {
        const errorMessage = rootState.entities.errorMessage.has(`${objectType}:${objectId}`)
            ? rootState.entities.errorMessage.get(`${objectType}:${objectId}`)
            : null;
        const isProcessing = rootState.entities.isProcessing.has(`${objectType}:${objectId}`)
            ? rootState.entities.isProcessing.get(`${objectType}:${objectId}`)
            : false;
        return { errorMessage, isProcessing };
    };
}
exports.stateByItemId = stateByItemId;
//# sourceMappingURL=selectors.js.map